import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import * as React from 'react';

import TabBarIcon from '../components/TabBarIcon';
import SettingsScreen from '../screens/SettingsScreen';
import HomeStack from './StacksNavigator';
import leftIcon from '../components/LeftIcon';
import { Drawer } from 'native-base';
import SideBar from '../screens/sideBar';

const BottomTab = createBottomTabNavigator();
const INITIAL_ROUTE_NAME = 'Home';

export default function BottomTabNavigator({ navigation, route }) {
  const drawer = React.useRef(null);
  // Set the header title on the parent stack navigator depending on the
  // currently active tab. Learn more in the documentation:
  // https://reactnavigation.org/docs/en/screen-options-resolution.html
  navigation.setOptions({
    headerTitle: getHeaderTitle(route),
    headerShown: showHeader(route),
    
    // headerLeft: () => (
    //   leftIcon(drawer, 'menu')
    // ),
  });
  // console.log(navigation);


  return (
    <BottomTab.Navigator initialRouteName={INITIAL_ROUTE_NAME}>
      {/* <Drawer
        ref={drawer}
        content={<SideBar />}
      > */}
        <BottomTab.Screen
          name="Home"
          component={HomeStack}
          options={{
            title: 'Escritorio',
            tabBarIcon: ({ focused }) => <TabBarIcon focused={focused} name="md-code-working" />,
          }}
        />
      {/* </Drawer> */}
      <BottomTab.Screen
        name="SettingsScreen"
        component={SettingsScreen}
        options={{
          title: 'Configuración',
          tabBarIcon: ({ focused }) => <TabBarIcon focused={focused} name="md-settings" />,
        }}
      />
    </BottomTab.Navigator>
  );
}

function getHeaderTitle(route) {
  const routeName = route.state?.routes[route.state.index]?.name ?? INITIAL_ROUTE_NAME;
  const parent = route.state ? route.state.routes[route.state.index].state : null;
  const childName = parent ? parent.routes[parent.index].name : null
  switch (routeName) {
    case 'Home':
      switch (childName) {
        case 'HomeScreen':
          return 'Escritorio';
        case 'CreateDeducibleExpence':
          return 'Crear gasto';
        default:
          return 'Escritorio';
      }
    case 'SettingsScreen':
      return 'Configuración';
  }
}

function showHeader(route) {
  const routeName = route.state?.routes[route.state.index]?.name ?? INITIAL_ROUTE_NAME;
  switch (routeName) {
    case 'SettingsScreen':
      return true;
    default:
      return false;
  }
}
